import axios, { AxiosResponse } from 'axios';

import { getCookie, removeCookie, setCookie } from '../utils/CookieHelper';

// Define os nomes dos cookies utilizados
const TOKEN_KEY = 'zignet_acc_tkn';
const REFRESH_TOKEN_KEY = 'zignet_ref_tkn';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: {
    'Request-Environment': 'frotas',
  },
});

// Funções para manipular o cookie do token
export const setTokenCache = (token: string) => {
  setCookie(TOKEN_KEY, token);
};

export const getTokenCache = (): string | undefined => {
  return getCookie(TOKEN_KEY);
};

export const removeTokenCache = () => {
  removeCookie(TOKEN_KEY);
};

// Funções para manipular o cookie do refreshToken
export const setRefreshTokenCache = (refreshToken: string) => {
  setCookie(REFRESH_TOKEN_KEY, refreshToken);
};

export const getRefreshTokenCache = (): string | undefined => {
  return getCookie(REFRESH_TOKEN_KEY);
};

export const removeRefreshTokenCache = () => {
  removeCookie(REFRESH_TOKEN_KEY);
};

api.interceptors.request.use(
  async (config) => {
    const token = getTokenCache();

    if (token && !config.headers.authorization) {
      config.headers.authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;

    if (error.response.status === 403) {
      delete api.defaults.headers.authorization;
      removeRefreshTokenCache();
      removeTokenCache();
    }

    if (error.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      try {
        const response = await api.post('/frotas/refresh-token', {
          refreshToken: getRefreshTokenCache(),
        });

        console.log('refresh response aqui', response);
        const { AccessToken, RefreshToken } =
          response?.data?.AuthenticationResult;

        setTokenCache(AccessToken);
        // setRefreshTokenCache(RefreshToken); // refresh token não vem nessa req (?)

        return api(originalConfig);
      } catch (err) {
        removeTokenCache();
        removeRefreshTokenCache();

        // redireciona para a página de login
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
      }
    }

    return Promise.reject(error);
  },
);

export { api };
